/* __next_internal_client_entry_do_not_use__ Progress auto */ import { jsx as _jsx } from "react/jsx-runtime";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";
import { cn } from "@/lib/utils";
const Progress = /*#__PURE__*/ React.forwardRef((param, ref)=>{
    let { className, value, ...props } = param;
    return /*#__PURE__*/ _jsx(ProgressPrimitive.Root, {
        ref: ref,
        className: cn("relative h-4 w-full overflow-hidden rounded-full bg-secondary progress-root", className),
        ...props,
        children: /*#__PURE__*/ _jsx(ProgressPrimitive.Indicator, {
            className: "h-full w-full flex-1 bg-primary transition-all progress-indicator",
            style: {
                transform: "translateX(-".concat(100 - (value || 0), "%)")
            }
        })
    });
});
Progress.displayName = ProgressPrimitive.Root.displayName;
export { Progress };
